import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, message, FormInstance } from 'antd';

import { useOwnerDetails } from 'api/owners';
import { guestyApi } from 'api/partners';
import { Spin, Typography, Modal, InputUIKit } from 'ui-kit';

import './PartnerConnect.scss';
import { useSignedUser } from 'api/auth';

GuestyConnect.propTypes = {
  visible: PropTypes.bool,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

export default function GuestyConnect({ visible, onSubmit, onClose }) {
  const { data: user } = useSignedUser();
  const { invalidate } = useOwnerDetails(user?.owner_id);
  const [formDetails, setFormDetails] = useState({ integrationToken: '' });
  const [isLoading, setLoading] = useState(false);

  const formRef = useRef<FormInstance | null>(null);

  const handleSubmit = () => {
    formRef.current.validateFields().then((values) => {
      setLoading(true);
      guestyApi
        .createOauth({ owner: user.owner_id, integrationToken: values.integrationToken })
        .then((res) => {
          if (res.ok) {
            message.success('Integration token saved successfully!');
            setFormDetails({ integrationToken: values.integrationToken });
            invalidate();
            onSubmit();
            setLoading(false);
          } else {
            message.error(res.data || 'Error adding integration token!');
          }
        });
    });
  };

  return (
    <Modal
      visible={visible}
      onOk={handleSubmit}
      onCancel={onClose}
      okText="Submit"
      okButtonProps={{ disabled: isLoading }}
      cancelButtonProps={{ hidden: true, disabled: true }}
    >
      <Spin spinning={isLoading}>
        <Typography variant="body1">Add your Guesty Integration Token here:</Typography>

        <Form ref={formRef} layout="vertical" initialValues={formDetails}>
          <div>
            <Form.Item
              name="integrationToken"
              rules={[
                {
                  required: true,
                  message: 'Please input your integration token',
                },
              ]}
            >
              <InputUIKit placeholder="Integration Token" />
            </Form.Item>
          </div>
        </Form>
        <Typography variant="caption">
          Don’t have a token yet? Head over to our{' '}
          <a
            href="https://app.guesty.com/integrations/partners/thehostco"
            target="_blank"
            rel="noreferrer"
            className="Integration_external_link"
          >
            Guesty Marketplace page
          </a>{' '}
          and hit &quot;Connect&quot;.
        </Typography>
      </Spin>
    </Modal>
  );
}
